<template>
  <section class="relative overflow-hidden bg-gradient-dark">
    <div class="absolute inset-0 bg-black opacity-60"></div>
    <div class="relative container mx-auto px-6 py-24 md:py-32">
      <div class="max-w-3xl mx-auto text-center">
        <h1 class="text-5xl md:text-7xl font-display font-bold text-gold-400 mb-6">
          Your Perfect Smile Awaits
        </h1>
        <div class="flex flex-col sm:flex-row gap-6 justify-center">
          <router-link to="/services" class="btn-secondary">
            Explore Products
          </router-link>
        </div>
      </div>
    </div>

    <!-- Decorative elements -->
    <div class="absolute top-10 left-10 w-20 h-20 border-2 border-gold-500 rounded-full opacity-20"></div>
    <div class="absolute bottom-10 right-10 w-32 h-32 border-2 border-gold-500 rounded-full opacity-20"></div>
    <div class="absolute top-1/3 right-1/4 w-16 h-16 border border-gold-400 rounded-full opacity-30"></div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>